import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { observer } from 'mobx-react-lite';

import { Paper, Typography } from '@mui/material';

import { isPortrait } from '../utils';
import { useAuthApi } from '../ApiClient';

const ResetPasswordPage = observer((): JSX.Element => {
  const authApi = useAuthApi();

  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const prefix = `${window.location.origin}/passwort-zuruecksetzen/`;

    try {
      await authApi.sendPasswordResetEmail(email, prefix, 'customer');
      setMsg('Email wurde versendet');
    } catch (e) {
      setMsg('Email konnte nicht versendet werden');
    }
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '85vh',
      }}
    >
      <Box
        sx={{
          display: isPortrait() ? 'block' : 'flex',
        }}
      >
        <Paper sx={{ padding: 1 }} elevation={0}>
          {msg ? (
            <>
              <Typography
                component="h1"
                variant="h4"
                align="center"
                color="secondary"
              >
                {msg}
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', pt: 4 }}>
                <Button
                  variant="contained"
                  onClick={() => setMsg('')}
                  sx={{ paddingX: 4, mt: 3, mb: 2 }}
                >
                  zurück
                </Button>
              </Box>
            </>
          ) : (
            <>
              <Typography
                component="h1"
                variant="h4"
                align="center"
                color="secondary"
              >
                Passwort zurücksetzen
              </Typography>
              <Box component="form" onSubmit={handleSubmit} noValidate>
                <TextField
                  sx={{ input: { color: '#58585A' } }}
                  variant="standard"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label="Email"
                  name="email"
                  autoComplete="email"
                  autoFocus
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />

                <Box sx={{ display: 'flex', justifyContent: 'center', pt: 4 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={!email}
                    sx={{ paddingX: 4, mt: 3, mb: 2 }}
                  >
                    Rücksetz-Email anfordern
                  </Button>
                </Box>
              </Box>
            </>
          )}
        </Paper>
      </Box>
    </Container>
  );
});

export default ResetPasswordPage;
